<div class="full-height flex layout-row">

  <!--Main Totals-->
  <div class="layout-row layout-align-start-center gap-10">
    <span class="br-body-1 font-weight-600">{{routes?.length || 0}} {{routes?.length === 1 ? 'Route' : 'Routes' | translate}}</span>
    <span class="br-body-1 font-weight-600">{{aggregatedServiceIdList?.length || 0}} {{aggregatedServiceIdList?.length === 1 ? 'Service' : 'Services' | translate}}</span>
  </div>

  <span class="flex"></span>

  <!--Load Totals-->
  <div class="layout-row gap-10">

    <!--Number Of Packages-->
    <div class="layout-row layout-align-start-center">
      <bringoz-icon fill="#7E7E7E" iconName="package-outline"></bringoz-icon>
      <span class="br-body-1 color-gray-100">{{totals.numberOfPackages}}</span>
    </div>

    <!--Weight-->
    <div class="layout-row layout-align-start-center">
      <bringoz-icon fill="#7E7E7E" iconName="weight"></bringoz-icon>
      <span class="br-body-1 color-gray-100">{{totals.weightLoad | bringozWeight: true}}</span>
    </div>

    <!--Volume-->
    <div class="layout-row layout-align-start-center">
      <bringoz-icon fill="#7E7E7E" iconName="weight"></bringoz-icon>
      <span class="br-body-1 color-gray-100">{{totals.calculatedVolume | bringozVolume: true}}</span>
    </div>

    <!--Distance-->
    <div class="layout-row layout-align-start-center">
      <bringoz-icon fill="#7E7E7E" iconName="distance"></bringoz-icon>
      <span class="br-body-1 color-gray-100">{{totals.totalDistanceMeter | bringozDistance}}</span>
    </div>

  </div>

</div>
